import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import DeprecatedApp from './shared/DeprecatedApp';
import * as serviceWorker from './serviceWorker';
import appConfig from './app-config.json';

// Determine environment from app config or fallback to URL-based detection
const getEnvironment = () => {
  if (appConfig.environment) {
    return appConfig.environment;
  }
  // Fallback: detect from API URL if environment field not present
  const apiUrl = appConfig.apiUri || '';
  if (apiUrl.includes('dev-api')) return 'development';
  if (apiUrl.includes('stg-api')) return 'staging';
  if (apiUrl.includes('pen-api')) return 'penetration';
  if (apiUrl.includes('api.myverdata.com')) return 'production';
  // Local development
  if (apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1')) return 'local';
  return 'unknown';
};

const environment = getEnvironment();

// Only initialize Sentry for non-local environments
if (environment !== 'local' && environment !== 'unknown') {
  Sentry.init({
    dsn: "https://668517ea580e2ca3733609f997de95bf@o4509441827209216.ingest.us.sentry.io/4509593696468992",
    sendDefaultPii: true,
    environment: environment,
    integrations: [
      new BrowserTracing(),
      new Sentry.Replay(),
    ],
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
} else {
  console.log('Sentry disabled for local development (environment:', environment, ')');
}

// Initialize Heap analytics if heapEnvId is configured
if (appConfig.heapEnvId && window.heap && window.heap.load) {
  window.heap.load(appConfig.heapEnvId);
} else {
  console.log('Heap analytics disabled (no heapEnvId configured)');
}

// The legacy 1.0 application has been deprecated. Instead of mounting <App />
// (which bootstraps the Cognito session, login redirect and all routes), we
// render a single static notice pointing users to the new app. It is rendered
// for every URL path, before any login, so it cannot be bypassed by editing the
// route. The original application code is still in ./App for reference.
ReactDOM.render(
  <React.StrictMode>
    <DeprecatedApp />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
